<template>
  <div class="d-flex flex-column flex-grow-1 flex-fill mt-3">
    <div
      class="d-flex flex-column flex-grow-1 grey lighten-4 "
      style="border-radius: 3px;"
      v-if="cashPayments.length > 0"
    >
      <span
        class=" font font-size-md ml-2 mt-2 text-uppercase font-weight-medium"
        >All Credit Payments</span
      >

      <div
        v-for="(payment, index) in cashPayments"
        :key="index"
        class="d-flex flex-column flex-grow-1 my-1 white pa-2 ma-2 box-shadow-light"
      >
        <div class="d-flex flex-row flex-grow-1 pl-3 pr-3 pt-3 pb-1">
          <ValidationProvider
            v-slot="{ errors }"
            tag="div"
            rules="required"
            class="d-flex flex-grow-1"
          >
            <v-autocomplete
              dense
              :items="suppliers"
              item-value="id"
              autofocus
              item-text="name"
              return-object
              outlined
              prepend-icon="store"
              class="font font-weight-medium font-size-md"
              label="Choose a supplier"
              v-model="payment.supplierId"
              :error-messages="errors[0]"
            >
              <template v-slot:no-data>
                <v-list>
                  <v-list-item>
                    <span class="font font-weight-medium font-size-md"
                      >No suppliers' have been added yet.
                    </span>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:item="{ item }">
                <span class="font font-weight-medium font-size-md">{{
                  item.name
                }}</span>
              </template>
            </v-autocomplete>
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            tag="div"
            rules="required|decimals"
            class="d-flex flex-grow-1"
          >
            <v-text-field
              outlined
              label="Total Balance/Amount"
              prepend-icon="credit_card"
              :prefix="
                currency && currency.length > 0 ? currency[0].symbol : 'GHS'
              "
              class="font font-weight-medium font-size-md"
              dense
              v-model="payment.amount"
              :error-messages="errors[0]"
            />
          </ValidationProvider>
          <ValidationProvider tag="div" class="d-flex flex-column flex-grow-1">
            <v-text-field
              outlined
              dense
              v-model="payment.invoiceNumber"
              label="Invoice or Payment No."
              prepend-icon="receipt_long"
              hint="Invoice or payment number."
              class=" font font-weight-medium font-size-md"
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            tag="div"
            v-if="salesPaymentOptions.length > 0"
            rules="required"
            class="d-flex flex-grow-1"
          >
            <v-autocomplete
              dense
              outlined
              :items="salesPaymentOptions"
              item-value="id"
              v-model="payment.isPaymentMadeFromSalesAmount"
              item-text="value"
              prepend-icon="store"
              class="font font-weight-medium font-size-md"
              label="Choose Source Of payment"
              :error-messages="errors[0]"
            >
              <template v-slot:no-data>
                <v-list>
                  <v-list-item dense>
                    <span class="font font-weight-medium font-size-md"
                      >No suppliers' have been added yet.
                    </span>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:item="{ item }">
                <span class="font font-weight-medium font-size-md">{{
                  item.value
                }}</span>
              </template>
            </v-autocomplete>
          </ValidationProvider>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                color="red"
                class="mt-1"
                @click.stop="removeCashPayment(index)"
                small
              >
                <i class="material-icons-outlined">delete</i>
              </v-btn>
            </template>
            <span class="font font-weight-medium font-size-sm"
              >Remove Item</span
            >
          </v-tooltip>
        </div>
      </div>
      <div class="d-flex flex-row justify-end my-2 mr-2 mb-2 flex-grow-1">
        <v-btn
          @click="addCashPayment"
          :disabled="
            totalSalesAmount <= totalAmountTallied && hasMDsAllocationTallied
          "
          small
          color="primary"
        >
          <span
            class="font font-weight-medium font-size-sm"
            style="font-size: 12px !important;"
          >
            Add Credit Payment
          </span>
        </v-btn>
      </div>
    </div>
    <div
      v-else
      class="d-flex flex-column flex-grow-1 my-1 justify-center grey lighten-4 pa-5"
      style="align-items:center;"
    >
      <img src="@/assets/online-payment.svg" style="width: 80px;" />
      <span class="font font-weight-medium"
        >Record all cash/credit payments made on
        <kbd class="ml-1">{{ date }}</kbd> shop activities or operations</span
      >
      <span class="font font-weight-medium font-size-sm"
        >Cash/Credit payments includes part payment to suppliers on goods
        acquired by credit.</span
      >
      <v-btn
        @click="addCashPayment"
        :disabled="
          totalSalesAmount <= totalAmountTallied && hasMDsAllocationTallied
        "
        color="primary"
        class="mt-2"
      >
        <span
          class="font font-weight-medium font-size-sm"
          style="font-size: 12px !important;"
          >Add Credit Payment</span
        >
      </v-btn>
    </div>
  </div>
</template>
<script>
import { extend, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { decimals } from "../../utils/resolvers";
extend("required", {
  ...required,
  message: "Input field is required"
});
extend(decimals, decimals);
export default {
  name: "RecordCashPayments",
  props: {
    date: String,
    currency: {
      type: Array,
      default: () => []
    },
    cashPayments: {
      type: Array,
      default: () => []
    },
    suppliers: {
      type: Array,
      default: () => []
    },
    salesPaymentOptions: {
      type: Array,
      default: () => []
    },
    totalSalesAmount: {
      type: Number,
      default: 0
    },
    totalAmountTallied: {
      type: Number,
      default: 0
    },
    hasMDsAllocationTallied: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidationProvider
  },
  data: () => ({}),
  methods: {
    addCashPayment() {
      this.$emit("addCashPayment", {
        supplierId: "",
        amount: "",
        invoiceNumber: "",
        isPaymentMadeFromSalesAmount: "",
        type: "cash-payment"
      });
    },
    removeCashPayment(index) {
      this.cashPayments.splice(index, 1);
    }
  }
};
</script>
